import { useEffect, useState } from "react";
import { getTheme, onThemeChange, type Theme } from "../utils/theme";

export function useTheme(): Theme {
  const [theme, setTheme] = useState<Theme>(getTheme);

  useEffect(() => onThemeChange(setTheme), []);

  return theme;
}
